import React, { createContext, useContext } from 'react';

const RbacContext = createContext();

export const RbacProvider = ({ children }) => {
  const permissions = JSON.parse(localStorage.getItem('permissions')) || [];

  const hasPermission = (permission) => {
    return permissions.includes(permission);
  };

  return (
    <RbacContext.Provider
      value={{
        permissions,
        hasPermission,
      }}>
      {children}
    </RbacContext.Provider>
  );
};

export const usePermission = () => {
  const context = useContext(RbacContext);

  if (!context) {
    throw new Error('usePermission must be used within PermissionProvider');
  }

  return context;
};
